/* global axios */
import ApiClient from './ApiClient';

class ContactSegmentsAPI extends ApiClient {
  constructor() {
    super('contact_segments', { accountScoped: true });
  }

  contacts(segmentId, page = 1) {
    return axios.get(`${this.url}/${segmentId}/contacts`, {
      params: { page },
    });
  }

  preview({ matchType, conditions, page = 1 }) {
    return axios.post(`${this.url}/preview`, {
      match_type: matchType,
      conditions,
      page,
    });
  }
}

export default new ContactSegmentsAPI();
